<template>
  <base-cell
    class="outreach-cell"
    v-on="!responsive.lg ? { click: clickViewReport }: {}"
  >
    <div class="w-100">
      <!-- Header -->
      <div class="outreach-cell__header">
        <div class="d-flex justify-content-between">
          <base-text
            medium
            muted
            class="outreach-cell__type"
          >
            <!-- Type of contact (Email, Link, PDF, Appointment, etc) -->
            {{ render_contact_type(item.contact_type) }}
          </base-text>
        </div>
      </div>
      <!-- Body -->
      <div class="d-flex pl-3 pt-2">
        <div
          v-if="item.appointment"
          class="entry__thumbnail d-flex justify-content-center align-items-center"
        >
          <base-icon
            v-if="item.appointment.appointment_type === APPOINTMENT_TYPES.RECOMMENDATION"
            icon="star-gray"
          />
          <base-icon
            v-else
            icon="video-camera-gray"
          />
        </div>
        <div
          v-else-if="item.backgroundImage"
          class="entry__thumbnail"
          :class="browserClass"
        >
          <div
            class="entry__thumbnail__image"
            :style="{'background-image': `url(${item.backgroundImage}?w=83&h=83&dpr=2)`}"
          />
        </div>
        <div
          v-else
          class="entry__thumbnail"
        >
          <div class="d-flex entry__thumbnail__image">
            <div
              class="empty-item mr-2"
            />
            <div
              class="empty-item"
            />
          </div>
        </div>
        <div class="align-self-center">
          <base-text
            semibold
            style="font-size: 14px; line-height: 16px;"
            class="mb-1"
          >
            {{ item.subject ? item.subject : 'Untitled' | striphtml }}
          </base-text>
          <template v-if="item.clients">
            <base-text
              light
              class="pb-1"
              style="line-height: 16px; font-size: 14px;"
            >
              {{ item.clients }}
            </base-text>
          </template>
          <base-text
            muted
            class="entry__date text-footer"
          >
            <span
              v-if="showSender"
              class="pr-2"
            >By: {{ item.sender.first_name }} {{ item.sender.last_name }}</span>
            {{ item.time | nicedate('custom', 'MMM DD, YYYY h:mm a') }}
          </base-text>
        </div>
        <div class="ml-auto d-flex">
          <div class="align-self-center d-flex justify-content-end">
            <div
              v-for="(event, index) in item.events"
              :key="`${index}__outreach_event`"
            >
              <!-- Events (clicks, opens, likes, etc) -->
              <div class="events">
                <base-text
                  uppercase
                  light
                  style="color: #AAAAAA; font-size: 11px; margin-bottom: 6px;"
                >
                  {{ event.label }}
                </base-text>
                <base-text
                  style="font-size: 15px; line-height: 18px;"
                >
                  {{ event.value }}
                </base-text>
              </div>
            </div>
          </div>
          <div class="button-container">
            <base-button
              v-if="responsive.lg"
              small
              class="outreach__button"
              @click="clickViewReport()"
            >
              View Report
            </base-button>
          </div>
        </div>
      </div>
    </div>
  </base-cell>
</template>

<script>

import whichbrowser from '@/components/mixins/whichbrowser';
import responsive from '@/components/mixins/responsive';
import { EDIT_DISPLAY, APPOINTMENT_TYPES } from '@/_utilities/Enums';

export default {
  name: 'OutReachCell',
  mixins: [whichbrowser, responsive],
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    showSender: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      APPOINTMENT_TYPES,
    };
  },
  methods: {
    render_contact_type(contactType) {
      const titles = {};
      titles[EDIT_DISPLAY.EMAIL] = 'Email';
      titles[EDIT_DISPLAY.PDF] = 'PDF';
      titles[EDIT_DISPLAY.LINK] = 'Share Link';
      titles[EDIT_DISPLAY.WECHAT] = 'WeChat';
      titles[EDIT_DISPLAY.EMBED] = 'Embed Code';

      if (contactType === EDIT_DISPLAY.APPOINTMENT) {
        // Check appointment type
        const suffix = {};
        suffix[APPOINTMENT_TYPES.VIRTUAL] = 'Virtual';
        suffix[APPOINTMENT_TYPES.LIVESTREAM] = 'Live Stream';
        suffix[APPOINTMENT_TYPES.IN_PERSON] = 'In Person';
        suffix[APPOINTMENT_TYPES.RECOMMENDATION] = 'Recommendation';
        return `${suffix[this.item.appointment.appointment_type]}`;
      }

      return titles[contactType || EDIT_DISPLAY.EMAIL];
    },
    clickViewReport() {
      this.$mixpanel.track('report_click', {
        report: this.item.pk,
        account_id: this.$store.state.account.user.user.email,
      });
      this.$emit('button-clicked');
    },
  },
};
</script>

<style lang="scss" scoped>

.outreach-cell {
  border: 1px solid #D4D4D4;
  box-sizing: border-box;
  border-radius: 5px;
  padding: 0 0 .75rem 0;
  overflow: hidden;

  &__header {
    height: 33px;
    background-color: #FAF9F7;
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 10px;
    padding-bottom: 10px;

  }

  &__type{
    font-size: 14px;
    line-height: 1;
    color: #646464;
  }

}
.entry{
  &__date{
    font-size:11px;
    line-height: 13.2px;
    color: $gray-light-2;
  }
}

.entry__thumbnail {
  background-color: #FFFFFF;
  display: inline-block;
  min-width: 83px;
  height: 83px;
  margin: 0 32px 0 0;
  overflow: hidden;

  &__image {
    width: 83px;
    height: 83px;
    overflow: hidden;
    background-size: cover;
    background-position: center;
    display: block;
  }
}

.events {
  display: flex;
  min-width: 85px;
  flex-direction: column;
  align-items: center;
}

.outreach__button {
  border: solid 1px #C6C6C6;
  font-size: 0.6875rem;
  border-radius: 5px;
  color: #333333;
  white-space: nowrap;
  width: 100%;
  &.is-chrome {
    border: none;
    box-shadow: 0 0 0 0.75px #aaa;
  }
}

.empty-item {
  background: #F5EFEB;
  width: 75px;
  height: 147px;
}

.button-container {
  display: flex;
  align-items: center;
  margin-right: 12px;
  margin-left: 0px;
}
.text-footer{
  color: #767676;
  font-family: 'SilkaLight';
}
</style>
